import { BrowserDocumentOpener } from '@/infra/adapters/browser-document-opener/browser-document-opener'
import { RemoteOpenNfse } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { OpenNfse } from '@/domain/usecases'
import env from '@/main/config/env'

export const makeOpenNfse = (): OpenNfse => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteOpenNfse(url, httpClient, new BrowserDocumentOpener())
}
